module.exports = __webpack_public_path__ + "static/case-fintech-hero-phone-0d299dcd65e1d9d49b9d73df191c78de.png";